class StaffUsersController {
  /* @ngInject */
  constructor($log, Users) {
    Object.assign(this, {
      $log,
      Users,
      users: [],
      status: "?active=true",
      statuses: [{
        id: 0,
        name: "Active",
        value: "?active=true"
      }, {
        id: 1,
        name: "Inactive",
        value: "?active=false"
      }, {
        id: 2,
        name: "All",
        value: ""
      }],
    });
    this.getStaffUsers();
  }

  getStaffUsers() {
    this.Users.getStaffUsers(this.status).then(({
      data
    }) => {
      this.users = data;
    }).catch(err => {
      this.users = [];
      this.$log.error(err);
    });
  }

}

StaffUsersController.$inject = ["$log", "Users"];
angular.module('pims').controller('StaffUsersController', StaffUsersController);
